import firebase from "firebase";
import { db, auth } from "../../Firebase/firebase";
import { vuexfireMutations, firestoreAction } from "vuexfire";
import router from "../../router/index";
import { Date } from "core-js";
import Vue from "vue";

const increment = firebase.firestore.FieldValue.increment(1);
const decrement = firebase.firestore.FieldValue.increment(-1);

export default {
  namespaced: true,
  state: {
    currentCompany: null,
    currentMenu: null,
  },
  mutations: {
    UPDATE_CURREENT_COMPANY(state, company) {
      state.currentCompany = company;
    },
    UPDATE_CURRENT_MENU(state, menu) {
      menu.categories.map((item) => {
        if (!state[item.name]) {
          Vue.set(state, item.name, []);
        }
      });
      state.currentMenu = menu;
    },
    SET_CATEGORY(state, category) {
      if (!state[category]) {
        Vue.set(state, category, []);
      }
    },
    ...vuexfireMutations,
  },

  actions: {
    async getCurrentCompany({ commit, dispatch }, username) {
      const company = [];
      await db
        .collection("users")
        .where("username", "==", username)
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            company.push({ id: doc.id, ...doc.data() });
          });
        });
      commit("UPDATE_CURREENT_COMPANY", company[0]);
      return company[0];
    },

    async getCurrentMenu({ commit, dispatch }, { username, menu_slug }) {
      const company = await dispatch("getCurrentCompany", username);
      const menu = [];
      await db
        .collection("menus")
        .doc(company.id)
        .collection("userMenus")
        .where("slug", "==", menu_slug)
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            menu.push({ id: doc.id, ...doc.data() });
          });
        });
      commit("UPDATE_CURRENT_MENU", menu[0]);

      return menu[0];
    },

    fetchItems: firestoreAction(
      ({ commit, dispatch, state, bindFirestoreRef }, { menuId, category }) => {
        commit("SET_CATEGORY", category);
        return bindFirestoreRef(
          category,
          db
            .collection("menusItems")
            .doc(menuId)
            .collection("menuItems")
            .where("category", "==", category)
            .where("is_active", "==", true)
            .orderBy("createdAt", "desc")
        );
      }
    ),

    async callWaiter(
      { commit, dispatch },
      { companyId, menuId, table, companyName, menu_slug }
    ) {
      const batch = db.batch();
      const waiterRequestRef = db
        .collection("notifications")
        .doc(companyId)
        .collection("notification")
        .doc();
      const notifications_count = db
        .collection("notifications")
        .doc(companyId)
        .collection("notification")
        .doc("--count--");

      batch.set(waiterRequestRef, {
        menuId,
        is_active: true,
        type: "waiter_request",
        timestamp: firebase.firestore.FieldValue.serverTimestamp(),
        companyName,
        menu_slug,
        ...table,
      });
      batch.set(
        notifications_count,
        { total: increment, waiter_request: increment },
        { merge: true }
      );
      return batch.commit();
    },

    async endRequest({ commit, dispatch }, { companyId, menuId, table }) {
      const batch = db.batch();
      let notifications = [];
      const getNotif = await db
        .collection("notifications")
        .doc(companyId)
        .collection("notification")
        .where("number", "==", table.number)
        .where("message", "==", table.message)
        .where("is_active", "==", true)
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            notifications.push({ id: doc.id, ...doc.data() });
          });
        });

      const waiterRequestRef = db
        .collection("notifications")
        .doc(companyId)
        .collection("notification")
        .doc(notifications[0].id);
      const notifications_count = db
        .collection("notifications")
        .doc(companyId)
        .collection("notification")
        .doc("--count--");

      batch.update(waiterRequestRef, { is_active: false });
      batch.set(
        notifications_count,
        { total: decrement, waiter_request: decrement },
        { merge: true }
      );

      return batch.commit();
    },
  },
};
